import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { QRCodeComponent } from 'angularx-qrcode';

@Component({
    selector: 'app-qr-viewer',
    standalone: true,
    imports: [QRCodeComponent],
    templateUrl: './qr-viewer.component.html',
    styleUrl: './qr-viewer.component.scss'
})
export class QrViewerComponent {

  qrData:any;

  constructor( private dialogRef: MatDialogRef<QrViewerComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any){

      this.qrData=this.data;
  }



}
